import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { DefaultButton } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withCustomRendering } from '../custom-component';

const ActionButton = ({
  label, iconName, iconStyles, ariaLabel, onClick, ...rest
}) => {
  const i18n = useContext(I18nContext);
  const buttonIcon = iconName && {
    iconName,
    styles: iconStyles || {
      root: {
        color: '#0078D4',
      },
    },
  };

  return (
    <div className="header-action-button">
      <DefaultButton iconProps={buttonIcon} onClick={onClick} ariaLabel={ariaLabel} {...rest}>{i18n.getString(label)}</DefaultButton>
    </div>
  );
};

ActionButton.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  iconName: PropTypes.string,
  iconStyles: PropTypes.shape({}),
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

ActionButton.defaultProps = {
  iconName: null,
  iconStyles: null,
};

const ActionButtonWrapped = withCustomRendering(ActionButton);

export { ActionButtonWrapped as ActionButton };
